var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '../styled-components';
import { SIDEBAR_WIDTH } from './constants';
export var Body = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-grow: 1;\n  padding-left: ", ";\n\n  @media print {\n    padding: 0;\n  }\n"], ["\n  display: flex;\n  flex-grow: 1;\n  padding-left: ", ";\n\n  @media print {\n    padding: 0;\n  }\n"])), SIDEBAR_WIDTH);
var templateObject_1;
